import { inject, injectable } from "inversify";
import { BehaviorSubject, Observable } from "rxjs";
import { filter, skip } from "rxjs/operators";
import { ISessionService } from "../interfaces/sessionService";
import { SessionDto, IApiClient, IApiClientId } from "@se/platform";

@injectable()
class SessionService implements ISessionService {

    private session$: BehaviorSubject<SessionDto>;

    constructor(
        @inject(IApiClientId) private apiClient: IApiClient) {
        this.session$ = new BehaviorSubject(null);
    }

    public async StartSession() {

        const response = await this.apiClient.Get<SessionDto>(location.origin, `account/session`, "");
        if (response.wasSuccessful)
        {
            this.session$.next(response.content);
        }
    }

    public EndSession() {
        sessionStorage.clear();
        this.session$.next(null);
    }

    public OnSessionStarted$(): Observable<SessionDto> {
        return this.session$.pipe(
            filter(session => session != null)
        );
    }
    
    public OnSessionEnded$(): Observable<SessionDto> {
        return this.session$.pipe(
            skip(1),
            filter(session => session == null)
        );
    }
}

export { SessionService }